import type React from 'react';
import PortfolioItemContext from '../../portfolio-item/PortfolioItemContext';
import { useContext } from 'react';
import NewlySharedContext from '../../NewlySharedChallenges/NewlySharedContext';
import ChallengeContext from './ChallengeContext';
import ChallengePortfolioContext from '@/components/ChallengePortfolio/ChallengePortfolioContext';
import { type ChallengeSummary } from '@/lib/types';
import { type DraftFunction } from 'use-immer';

type ChallengePortfolioItemContextProviderProps = {
  children: React.ReactNode;
};

const ChallengePortfolioItemContextProvider = ({
  children,
}: ChallengePortfolioItemContextProviderProps) => {
  const [isNewlyShared, , setNewlySharedChallenges] =
    useContext(NewlySharedContext);
  const [, setChallengePortfolio] = useContext(ChallengePortfolioContext);
  const [challenge, setChallenge] = useContext(ChallengeContext);

  const setChallengeSummary = (
    stateUpdateFunction: DraftFunction<ChallengeSummary>,
  ): void => {
    if (isNewlyShared) {
      setNewlySharedChallenges(newlySharedChallenges => {
        stateUpdateFunction(newlySharedChallenges[challenge.id]);
      });

      return;
    }

    setChallengePortfolio(challengePortfolio => {
      stateUpdateFunction(challengePortfolio.challenges[challenge.id]);
    });
  };

  const challengeApiEndpoint = `challenge-portfolio/challenges/${challenge.id}`;

  return (
    <PortfolioItemContext.Provider
      value={{
        portfolioItem: challenge,
        setPortfolioItem: setChallenge,
        setPortfolioItemSummary: setChallengeSummary,
        portfolioItemApiEndpoint: challengeApiEndpoint,
      }}
    >
      {children}
    </PortfolioItemContext.Provider>
  );
};

export default ChallengePortfolioItemContextProvider;
